<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
    <div
        class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
        <form [formGroup]="roleForm" (ngSubmit)="onSave()">
            <div>
                <h2 class="heading">
                    {{roleId ? 'Edit' : 'Add'}}
                </h2>
            </div>
            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="grid gap-4 md:grid-cols-2">

                <!-- Name -->
                <div class="space-y-1">
                    <label class="subheading">
                        Name <span class="text-red-600">*</span>
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <input formControlName="name" type="text" />
                        </div>
                    </div>
                    <div *ngIf="form.name.errors && submitted">
                        <div *ngIf="form.name.errors.required" class="error">
                            <p class="mt-2 text-red-600 text-xs">
                                Name is required
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">Permission(s) <span class="text-red-600">*</span></label>
                    <div>
                        <!-- Using items input with multiple selection -->
                        <ng-select [ngModelOptions]="{standalone: true}" [items]="permissionsList"
                            bindLabel="[permissionsList]" bindValue="permissions" [(ngModel)]="selectedPermission"
                            [multiple]="true" [clearable]="false" [closeOnSelect]="false"
                            placeholder="Select Permission Type" [searchable]="true"
                            (change)="onSelectPermission()">
                            <ng-template ng-header-tmp>
                                <div class="flex items-center px-1 py-1">
                                    <input id="selectAll" type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll($event)" class="mr-2  cursor-pointer" />
                                    <label for="selectAll" class="text-sm font-medium  cursor-pointer">{{isAllSelected() ? 'Unselect All' : ' Select All'}}</label>
                                </div>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <input id="item-{{index}}" type="checkbox" [ngModelOptions]="{standalone: true}"
                                    [ngModel]="item$.selected" />
                                {{item}}
                            </ng-template>
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div class="ng-value" *ngFor="let item of items | slice:0:2;index as index">
                                    <span class="ng-value-label">{{item}}</span>
                                </div>
                                <div class="ng-value" *ngIf="items.length > 2">
                                    <span class="ng-value-label">{{items.length - 2}} more...</span>
                                </div>
                            </ng-template>
                        </ng-select>
                        <div *ngIf="form.permissions.errors && submitted">
                            <div *ngIf="form.permissions.errors.required" class="error">
                                <p class="mt-2 text-red-600 text-xs">
                                    Permission is required
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Type
                    </label>
                    <div>
                        <select formControlName="type" name="" id="">
                            <option *ngFor="let item of types" [value]="item">{{item | capitalize}}</option>
                        </select>
                    </div>
                    <div *ngIf="submitted && form.type.errors">
                        <p *ngIf="form.type.errors.required" class="pt-1 text-red-600 text-xs">
                            Type is required
                        </p>
                    </div>
                   
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Status
                    </label>
                    <div>
                        <select formControlName="isActive">
                            <option [value]="true" >Active</option>
                            <option [value]="false">Inactive</option>
                        </select>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Description <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <textarea formControlName="description" name="" class="h-16"></textarea>
                        </div>
                        <div *ngIf="submitted && form.description.errors">
                            <p *ngIf="form.description.errors.required" class="pt-1 text-red-600 text-xs">
                                Description is required
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="flex justify-end gap-4">
                <button type="submit" class="btn btn-secondary">
                    {{roleId ? 'Update' : 'Save'}}
                </button>
            </section>
        </form>
    </div>
</section>